import React, { useState, useRef, useEffect } from "react"
import './styleUserInfo.css'
import INCSUBRoleList from "./roleList";

function INCSUBUserInfoCard({ obj, functionCrud }) {

    const [selectedRole, setSelectedRole] = useState('ROLE_SUPERADMIN');
    const roleListRef = useRef(null);
    const [roleListFlag, setRoleListFlag] = useState(false);

    /**
 * @author govind dindewad
 * addCrud - Invokes the CRUD function to add a user with a specific role.
 *
 * This function acts as a wrapper around the `functionCrud` callback to add a user. 
 * It passes the `obj`, operation type ('add'), and the `selectedRole` to the callback.
 *
 * @function
 *
 * Dependencies:
 * - `functionCrud`: A parent-defined callback for handling CRUD operations.
 * - `obj`: The user object being added.
 * - `selectedRole`: The role assigned to the user.
 *
 * Example Usage:
 * ```javascript
 * addCrud(); // Adds a user with the currently selected role.
 * ```
 */
    const addCrud = () => {
        // Invokes functionCrud with the current user object, 'add' operation, and the selected role.
        functionCrud(obj, 'add', selectedRole);
    };




    /**
 * @author govind dindewad
 * removeCrud - Invokes the CRUD function to remove a user.
 *
 * This function calls the `functionCrud` callback with the user object (`obj`), 
 * operation type ('remove'), and `null` as the role to remove a user.
 *
 * @function
 *
 * Dependencies:
 * - `functionCrud`: A parent-defined callback for handling CRUD operations.
 * - `obj`: The user object being removed.
 *
 * Example Usage:
 * ```javascript
 * removeCrud(); // Removes the user from the list.
 * ```
 */
    const removeCrud = () => {
        // Invokes functionCrud with the current user object, 'remove' operation, and no role (null).
        functionCrud(obj, 'remove', null);
    };



    /**
 * @author govind dindewad
 * selectionRole - Updates the selected role and triggers the add operation.
 *
 * This function updates the user's role by calling the `functionCrud` callback 
 * with the role, and it updates the local `selectedRole` state.
 *
 * @function
 * @param {string} role - The role to assign to the user.
 *
 * Dependencies:
 * - `functionCrud`: A parent-defined callback for handling CRUD operations.
 * - `obj`: The user object being modified.
 * - `setSelectedRole`: A state setter for updating the selected role.
 *
 * Example Usage:
 * ```javascript
 * selectionRole("admin"); // Assigns the role "admin" to the user and updates the state.
 * ```
 */
    const selectionRole = (role) => {
        // Updates the user's role by calling functionCrud with the selected role.
        functionCrud(obj, 'add', role);

        // Updates the local state to reflect the selected role.
        setSelectedRole(role);
    };



    /**
 * @author govind dindewad
 * useEffect - Handles outside click events for hiding the role list dropdown.
 *
 * This `useEffect` sets up an event listener to detect clicks outside of the 
 * `roleListRef` element and closes the dropdown when such a click occurs.
 *
 * @function
 *
 * Dependencies:
 * - `roleListRef`: A reference to the role list dropdown element.
 * - `setRoleListFlag`: A state setter to toggle the dropdown's visibility.
 *
 * Example Usage:
 * - Triggered automatically when the component mounts.
 * - Cleans up the event listener when the component unmounts.
 */

    useEffect(() => {
        // Defines a function to handle clicks outside the role list dropdown.
        function handleOutsideClick(event) {
            // Checks if the click target is outside the dropdown element.
            if (roleListRef && roleListRef.current && !roleListRef.current.contains(event.target)) {
                // Hides the dropdown by updating the state.
                setRoleListFlag(false);
            }
        }

        // Adds the click event listener when the component mounts.
        document.addEventListener("mousedown", handleOutsideClick);

        // Cleans up the event listener when the component unmounts.
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);


    return (
        <div className="INCSUBUserinfo_card">
            <div className="INCSUBUserinfo_card_nameimgno">
                <div className="INCSUBUserinfo_card_img">
                    <img className='INCSUB_UserImgTag' src={obj.userImage ? obj.userImage : '/assets/icons/common/defaultImage.png'} alt={`${'default'} img`} />
                </div>
                <div className="INCSUBUserinfo_card_nameno">
                    <p className="INCSUBUserinfo_card_name_para">{obj?.userFullName}</p>
                    <p className="INCSUBUserinfo_card_no_para">{obj?.userMobileNumber}</p>
                </div>
            </div>
            {obj.type === 0 &&
                <div className="INCSUBUserinfo_card_addBtn"><p onClick={addCrud}>Add</p></div>
            }
            {obj.type === 1 &&
                <div className="INCSUBUserinfo_card_selectrole_ctn">
                    <div className="INCSUBUserinfo_card_selectrole" onClick={() => setRoleListFlag(true)}>
                        {/* <div className="INCSUBUserinfo_card_selectroletext">
                            {selectedRole}
                        </div> */}

                        {/* {roleListFlag && <INCSUBRoleList selectionRole={selectionRole} ref={roleListRef} />} */}
                        <select className="INCSUBUser_roleselect" value={selectedRole} onChange={(e) => selectionRole(e.target.value)}>
                            <option value={'ROLE_SUPERADMIN'}>Super Admin</option>
                            {/* <option value={'ROLE_ADMIN'}>Admin</option>
                            <option value={'ROLE_CONTENTMANAGER'}>Content Manager</option>
                            <option value={'ROLE_SUPPORTMANAGER'}>Support Manager</option> */}
                        </select>
                    </div>
                    <svg onClick={removeCrud} style={{ cursor: 'pointer' }} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.4834 6.14844L6.4834 18.1484" stroke="#4880FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M6.4834 6.14844L18.4834 18.1484" stroke="#4880FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            }
        </div>

    )

}

export default INCSUBUserInfoCard